import countBy from './countBy.js';
import each from './each.js';
import eachRight from './eachRight.js';
import every from './every.js';
import filter from './filter.js';
import find from './find.js';
import findLast from './findLast.js';
import flatMap from './flatMap.js';
import flatMapDeep from './flatMapDeep.js';
import flatMapDepth from './flatMapDepth.js';
import forEach from './forEach.js';
import forEachRight from './forEachRight.js';
import groupBy from './groupBy.js';
import includes from './includes.js';
import invokeMap from './invokeMap.js';
import keyBy from './keyBy.js';
import map from './map.js';
import orderBy from './orderBy.js';
import partition from './partition.js';
import reduce from './reduce.js';
import reduceRight from './reduceRight.js';
import reject from './reject.js';
import sample from './sample.js';
import sampleSize from './sampleSize.js';
import shuffle from './shuffle.js';
import size from './size.js';
import some from './some.js';
import sortBy from './sortBy.js';

export default {
  countBy, each, eachRight, every, filter,
  find, findLast, flatMap, flatMapDeep, flatMapDepth,
  forEach, forEachRight, groupBy, includes, invokeMap,
  keyBy, map, orderBy, partition, reduce,
  reduceRight, reject, sample, sampleSize, shuffle,
  size, some, sortBy
};



// WEBPACK FOOTER //
// ./~/lodash-es/collection.default.js